import React from "react";
import Flex from "../box/Flex";
import LoadMoreButton from "./LoadMoreButton";
import { StyledTableCell } from "./TableCell.style";
import { StyledDashContainer, StyledDashLine, StyledDashSvg, StyledTableGroupingLoadMoreRow, } from "./TableGroupingPaginationRow.style";
const TableGroupingPaginationRow = ({ id, "data-insights": insightsAttr, isLoading, onNextPage, }) => {
    return (React.createElement(StyledTableGroupingLoadMoreRow, { role: "row" },
        React.createElement(StyledTableCell, { colSpan: 100, "aria-colspan": 100, role: "gridcell", "aria-colindex": 3 },
            React.createElement(Flex, { flexDirection: "row", justifyContent: "flex-start", alignItems: "center" },
                React.createElement(StyledDashContainer, null,
                    React.createElement(StyledDashSvg, null,
                        React.createElement(StyledDashLine, { x1: "1px", y1: "0px", x2: "1px", y2: "100%" }))),
                React.createElement(LoadMoreButton, { id: `${id}-more`, "data-insights": insightsAttr && `${insightsAttr}-more`, isLoading: isLoading, onClick: onNextPage, variant: "tertiary" })))));
};
export default TableGroupingPaginationRow;
//# sourceMappingURL=TableGroupingPaginationRow.js.map